import { FC, useMemo, useState } from "react";
import { Control, RegisterOptions } from "react-hook-form";
import { get, range } from "lodash-es";

import { Icon } from "shared/styles";
import { IOtherTextField } from "shared/types";
import { FancyButtonLink } from "shared/components";

import { FieldWrapperProps } from "../FieldWrapper";
import { Spacer } from "shared/layout";
import { Plus } from "shared/assets/icons";
import { space } from "shared/styles/constants";
import { ControlledTextField } from "../ControlledTextField/ControlledTextField";

export interface Props
  extends FieldWrapperProps,
    Omit<IOtherTextField, "label" | "type"> {
  control: Control;
  validation?: RegisterOptions;
  value?: Record<string, any>;
}

export const OtherTextField: FC<Props> = ({
  name,
  value,
  button,
  style,
  ...rest
}) => {
  const [nbOther, setNbOther] = useState(Object.keys(value || {}).length);

  const addButton = useMemo(
    () => (
      <FancyButtonLink onClick={() => setNbOther(nbOther + 1)}>
        <Spacer spaceDirection="horizontal" size="xxs" align="center">
          <Icon as={Plus} />
          <span>{button}</span>
        </Spacer>
      </FancyButtonLink>
    ),
    [button, nbOther]
  );

  return (
    <Spacer size="s" style={style}>
      {addButton}
      <div>
        <Spacer size="s" style={{ marginLeft: space.m }}>
          {range(nbOther).map((index) => {
            const isFirstFile = index === 0;
            const id = `${name}.${index}`;

            return (
              <ControlledTextField
                key={id}
                {...rest}
                name={id}
                hideLabel={!isFirstFile}
                value={get(value, id) || get(value, index)}
              />
            );
          })}
        </Spacer>
      </div>
    </Spacer>
  );
};
